<template>
  <div class="header-board">
    <el-card
      v-for="(card, index) in cardData"
      :key="index"
      class="header-card"
      :class="`card-${index + 1}`">
      <div slot="header" class="header">
        <div class="title">
          <span>{{ card.title }}</span>
          <span>({{ card.timeRange }})</span>
        </div>
        <div
          :style="{
            color: card.iconColor,
            background: card.iconBgColor,
          }">
          <i :class="card.iconClass"></i>
        </div>
      </div>
      <div class="content">
        <div class="content-left">
          <h1>{{ card.leftValue }}</h1>
          <div>{{ card.leftLabel }}</div>
        </div>
        <div class="content-right">
          <h1 :style="{ color: card.rightValueColor }">
            {{ card.rightValue }}
          </h1>
          <div>{{ card.rightLabel }}</div>
        </div>
      </div>
      <div class="footer">
        <div class="footer-left" :style="{ background: card.bgColorValue }">
          <div
            :style="{
              color: card.leftCompareValue ? card.leftCompareColor : '#6b7280',
            }">
            <template v-if="index === 0 || index === 3">
              <i
                v-if="
                  card.leftCompareValue &&
                  isPercentagePositive(card.leftCompareValue)
                "
                class="el-icon-top"></i>
              <i v-else class="el-icon-bottom"></i>
            </template>

            {{ card.leftCompareValue.replace('-','') || "-" }}
          </div>
          <div>{{ card.leftCompareLabel }}</div>
        </div>
        <div class="footer-right" :style="{ background: card.bgColorValue }">
          <div
            :style="{
              color: card.rightCompareValue ? card.rightCompareColor : '#6b7280',
            }">
            <template v-if="index === 0 || index === 3">
              <i
                v-if="
                  card.rightCompareValue &&
                  isPercentagePositive(card.rightCompareValue)
                "
                class="el-icon-top"></i>
              <i v-else class="el-icon-bottom"></i>
            </template>
            {{ card.rightCompareValue.replace('-','') || "-" }}
          </div>
          <div>{{ card.rightCompareLabel }}</div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  props: {
    dataObjNum: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      cardData: [
        {
          title: "工单创建数",
          timeRange: "工单创建时间",
          iconClass: "el-icon-document",
          iconColor: "#235cff",
          iconBgColor: "#e7eeff",
          leftValue: "0",
          leftLabel: "工单",
          rightValue: "0",
          rightLabel: "需求",
          rightValueColor: "#125aff",
          leftCompareValue: "0%",
          leftCompareLabel: "工单环比",
          leftCompareColor: "#00b329",
          rightCompareValue: "0%",
          rightCompareLabel: "需求环比",
          rightCompareColor: "#00b329",
          bgColorValue: "#f0fdf4",
        },
        {
          title: "工单待指派数",
          timeRange: "工单创建时间",
          iconClass: "el-icon-time",
          iconColor: "#ff7f0f",
          iconBgColor: "#fff2e5",
          leftValue: "0",
          leftLabel: "工单",
          rightValue: "0",
          rightLabel: "需求",
          rightValueColor: "#ff8050",
          leftCompareValue: "",
          leftCompareLabel: "工单环比",
          leftCompareColor: "#f5403f",
          rightCompareValue: "",
          rightCompareLabel: "需求环比",
          rightCompareColor: "#f5403f",
          bgColorValue: "#e9e9e9",
        },
        {
          title: "工单未完成数",
          timeRange: "期望交付时间",
          iconClass: "el-icon-warning",
          iconColor: "#f53f3f",
          iconBgColor: "#feebeb",
          leftValue: "0",
          leftLabel: "工单",
          rightValue: "0",
          rightLabel: "需求",
          rightValueColor: "#f53f3f",
          leftCompareValue: "",
          leftCompareLabel: "工单环比",
          leftCompareColor: "#00b329",
          rightCompareValue: "",
          rightCompareLabel: "需求环比",
          rightCompareColor: "#00b329",
          bgColorValue: "#e9e9e9",
        },
        {
          title: "素材上传数",
          timeRange: "素材上传时间",
          iconClass: "el-icon-upload2",
          iconColor: "#00b42a",
          iconBgColor: "#e5f7e9",
          leftValue: "0",
          leftLabel: "上传",
          rightValue: "0",
          rightLabel: "通过",
          rightValueColor: "#00b429",
          leftCompareValue: "0%",
          leftCompareLabel: "上传环比",
          leftCompareColor: "#00b329",
          rightCompareValue: "0%",
          rightCompareLabel: "通过环比",
          rightCompareColor: "#00b329",
          bgColorNoValue: "#e9e9e9",
          bgColorValue: "#f0fdf4",
        },
      ],
    }
  },
  watch: {
    dataObjNum: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.updateCardData(newVal)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    updateCardData(data) {
      // 工单创建数卡片
      if (this.cardData[0]) {
        this.cardData[0].leftValue = data.create_order_num || 0
        this.cardData[0].rightValue = data.create_demand_num || 0
        this.cardData[0].leftCompareValue = data.create_order_num_ratio || ""
        this.cardData[0].rightCompareValue = data.create_demand_num_ratio || ""
        this.cardData[0].leftCompareColor = this.isPercentagePositive(
          data.create_order_num_ratio
        )
          ? "#00b329"
          : "red"
        this.cardData[0].rightCompareColor = this.isPercentagePositive(
          data.create_demand_num_ratio
        )
          ? "#00b329"
          : "red"
       
      }

      // 工单待指派数卡片
      if (this.cardData[1]) {
        this.cardData[1].leftValue = data.unassigned_order_num || 0
        this.cardData[1].rightValue = data.unassigned_demand_num || 0
      }

      // 工单未完成数卡片
      if (this.cardData[2]) {
        this.cardData[2].leftValue = data.unfinished_order_num || 0
        this.cardData[2].rightValue = data.unfinished_demand_num || 0
      }

      // 素材上传数卡片
      if (this.cardData[3]) {
        this.cardData[3].leftValue = data.upload_material_num || 0
        this.cardData[3].rightValue = data.passed_material_num || 0
        this.cardData[3].leftCompareValue = data.upload_material_num_ratio || ""
        this.cardData[3].rightCompareValue =
          data.passed_material_num_ratio || ""

        this.cardData[3].leftCompareColor = this.isPercentagePositive(
          data.upload_material_num_ratio
        )
          ? "#00b329"
          : "red"
        this.cardData[3].rightCompareColor = this.isPercentagePositive(
          data.passed_material_num_ratio
        )
          ? "#00b329"
          : "red"

      }
    },
    isPercentagePositive(percentageStr) {
      // 移除百分号并转换为数值
      const num = parseFloat(percentageStr.replace("%", ""))

      // 检查转换是否成功
      if (isNaN(num)) {
        return false
      }

      // 正数返回true，负数返回false
      return num > 0
    },
  },
}
</script>

<style scoped lang="scss">
.header-board {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 20px;

  .header-card {
    width: 24%;
    border-radius: 10px;
    margin-bottom: 20px;

    ::v-deep(.el-card__header) {
      border-bottom: 0 !important;
      padding: 15px;
    }

    ::v-deep(.el-card__body) {
      padding-top: 0;
    }

    .header {
      display: flex;
      justify-content: space-between;

      .title {
        span:first-child {
          font-size: 14px;
        }

        span:last-child {
          font-size: 12px;
          color: #a3a6b1;
          margin-left: 10px;
        }
      }

      div:last-child {
        border-radius: 50%;
        width: 25px;
        height: 25px;
        text-align: center;
        line-height: 25px;
      }
    }

    .content {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;

      .content-left,
      .content-right {
        width: 50%;

        h1 {
          font-size: 26px;
        }
      }
    }

    .footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      margin-top: 20px;

      .footer-left,
      .footer-right {
        width: 49%;
        border-radius: 8px;
        // background: #f0fdf4;
        padding: 10px;

        div:first-child {
          font-weight: bold;
          margin-bottom: 6px;
        }
      }
    }
  }
}
</style>
